"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transition = exports.borderRadiusDarkTheme = exports.borderRadius = exports.font = exports.height = exports.screenReaderOnly = exports.buttonReset = void 0;

var _reactEmotion = require("react-emotion");

var buttonReset =
/*#__PURE__*/
(0, _reactEmotion.css)("box-sizing:border-box;display:flex;justify-content:flex-start;align-items:center;padding:0;border:0;border-radius:0;font:inherit;text-align:left;background-color:transparent;cursor:pointer;");
exports.buttonReset = buttonReset;
var screenReaderOnly =
/*#__PURE__*/
(0, _reactEmotion.css)("border:0 !important;clip:rect(1px,1px,1px,1px);height:1px !important;margin:-1px !important;overflow:hidden;padding:0 !important;position:absolute !important;width:1px !important;");
exports.screenReaderOnly = screenReaderOnly;
var height = {
  small: '20px',
  medium: '28px',
  large: '44px'
};
exports.height = height;
var font = {
  size: {
    small: '12px',
    medium: '14px',
    large: '16px',
    xl: '20px'
  },
  weight: {
    normal: 400,
    bold: 500
  }
};
exports.font = font;
var borderRadius = '4px';
exports.borderRadius = borderRadius;
var borderRadiusDarkTheme = '2px';
/* Generate transitions
for example:

  for these OPTIONS:
    const speeds = [{ slow: 600 }, { medium: 400 }, { fast: 200 }];
    const properties = ['background-color', 'box-shadow', '-webkit-border-radius'];
    const easings = ['ease-in'];


  OUTPUT will be:

    transition: {
      s-background-color:'600 background-color ease-in',
      s-background-color-ease:'600 background-color ease',
      s-box-shadow:'600 box-shadow ease-in',
      s-box-shadow-ease:'600 box-shadow ease',
      s-webkit-border-radius:'600 -webkit-border-radius ease-in',
      s-webkit-border-radius-ease:'600 -webkit-border-radius ease',
      m-background-color:'400 background-color ease-in',
      m-background-color-ease:'400 background-color ease',
      m-box-shadow:'400 box-shadow ease-in',
      m-box-shadow-ease:'400 box-shadow ease',
      m-webkit-border-radius:'400 -webkit-border-radius ease-in',
      m-webkit-border-radius-ease:'400 -webkit-border-radius ease',
      f-background-color:'200 background-color ease-in',
      f-background-color-ease:'200 background-color ease',
      f-box-shadow:'200 box-shadow ease-in',
      f-box-shadow-ease:'200 box-shadow ease',
      f-webkit-border-radius:'200 -webkit-border-radius ease-in',
      f-webkit-border-radius-ease:'200 -webkit-border-radius ease'
    }
*/

exports.borderRadiusDarkTheme = borderRadiusDarkTheme;
var speeds = [{
  slow: 600
}, {
  medium: 400
}, {
  fast: 200
}];
var properties = ['top', 'background-color', 'box-shadow', '-webkit-border-radius', 'font-size', 'transform'];
var easings = ['ease-in'];

var transition = function () {
  var transitions = {};
  speeds.forEach(function (speed) {
    properties.forEach(function (prop) {
      easings.forEach(function (easing) {
        var tEasing = easing === 'ease-in' ? '' : easing;
        var separator = tEasing ? '-' : '';
        var tName = Object.keys(speed)[0].charAt(0) + '-' + prop.replace(/^-/, '') + separator + tEasing;
        var tSpeed = Object.values(speed)[0] + 'ms';
        var tProp = prop;
        transitions[tName] = "".concat(tSpeed, " ").concat(tProp, " ").concat(easing);
      });
    });
  });
  return transitions;
}();

exports.transition = transition;